import { BaseModel } from "./BaseModel";

export class OrgLogType extends BaseModel {
  schema = "/orglogtype";
  constructor(params = {}) {
    return super(params, "/orglogtype");
  }
}
